<template>
  <div class="call-session">
    <transition name="loading">
      <div class="loading" ref="loading" v-show="isLoading"></div>
    </transition>
    <transition name="video-stream-state" mode="out-in">
      <div class="video-stream-state" key="initiated" v-if="callStatus === 'initiated'">Calling</div>
      <div class="video-stream-state" key="ringing" v-else-if="callStatus === 'ringing'">Ringing</div>
      <div class="video-stream-state errored" key="failed" v-else-if="callStatus === 'failed'">Failed</div>
      <div class="video-stream-state errored" key="canceled" v-else-if="callStatus === 'canceled'">Declined</div>
      <div class="video-stream-state errored" key="busy" v-else-if="callStatus === 'busy'">Busy</div>
      <div class="video-stream-state errored" key="no-answer" v-else-if="callStatus === 'no-answer'">No answer</div>
<!--      <div class="video-stream-state" key="no-answer" v-else-if="callStatus === 'auto_connect'">Waiting for user to connect</div>-->
      <VideoSession
        v-else
        key="video-session"
        :call-sid="callSid"
        :room-session="call.room"
        :contact="call.contact"
        :recording="call.recording"
        @disconnected="$emit('disconnected')"
      />
    </transition>
    <current-screenshot :call-sid="callSid" />
  </div>
</template>

<script>
  import ViButton from "../ui/ViButton";
  import VideoSession from "./VideoSession";
  import lottie from 'lottie-web';
  import CurrentScreenshot from "../screenshots/CurrentScreenshot";

  export default {
    components: {CurrentScreenshot, VideoSession, ViButton},
    props: {
      call: {
        type: Object,
        required: true
      },
      callSid: {
        type: String
      }
    },
    computed: {
      isVideoSessionStarted() {
        return this.callStatus  !== 'initiated' && this.callStatus  !== 'failed';
      },
      isLoading() {
        return ['initiated', 'ringing', 'failed', 'busy', 'canceled', 'no-answer'].includes(this.callStatus)
      },
      callStatus() {
        return this.call.status.toLowerCase()
      }
    },
    methods: {
      goBack() {
        this.$router.push('/tech/call');
      }
    },
    mounted() {
      this.animation = lottie.loadAnimation({
        container: this.$refs.loading,
        animationData: require('../../animations/animation_loading'),
        loop: true,
        renderer: 'svg',
      });

      if(['failed', 'busy', 'canceled', 'no-answer'].includes(this.callStatus)) {
        this.animation.goToAndStop(57, true);
        setTimeout(() => {
          this.$emit('disconnected')
        }, 3000)
      }

      this.$store.commit('global/setCallsInProgress', true)
    },
    beforeDestroy() {
      this.$store.commit('global/setCallsInProgress', false)
    },
    watch: {
      'callStatus'(status) {
        if(['failed', 'busy', 'canceled', 'no-answer'].includes(status)) {
          this.animation.goToAndStop(57, true);
          setTimeout(() => {
            this.$emit('disconnected')
          }, 3000)
        }
      }
    }
  }
</script>

<style lang="scss">
@import "CallSession";
</style>
